<template>
	<div @click.self="$emit('close')" class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-30">
		<div class="popup-bg text-[var(--popup-text-color)] rounded-lg p-8 w-10/12 md:w-3/6 lg:w-1/3 xl:w-1/4 relative">
			<button @click="$emit('close')" class="absolute top-4 right-4">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkX : lightX" alt="Close" class="w-3 h-3"/>
			</button>

			<h2 class="text-2xl font-archivomedium mb-4 text-center">
				Add Network
			</h2>

			<div class="flex flex-col">
				<div v-if="availableNetworks.length" class="space-y-2">
					<div v-for="network in availableNetworks" :key="network.name" @click="$emit('add-network', network)" class="group flex items-center justify-between bg-[var(--add-network-bg-color)] border border-[var(--accent-color)] hover:bg-[var(--accent-color)] transition duration-100 rounded-lg px-4 py-3 cursor-pointer">
						<div class="flex items-center">
							<img :src="network.icon" alt="Icon" class="w-6 h-6 mr-4" />
							<span class="font-archivoregular text-[var(--secondary-text-color)] group-hover:text-[var(--add-network-text-color)] transition duration-100">
								{{ network.name }}
							</span>
						</div>
						<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? plusIconDark : plusIcon" alt="Plus" class="w-6 h-6"/>
					</div>
				</div>

				<div v-else class="text-center text-[var(--accent-color)] rounded-lg border border-[var(--accent-color)] bg-transparent hover:scale-105 transition duration-500">
					<p class="text-lg font-archivosemibold animate-pulse px-4 py-3">
						No more networks to add… yet
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	import lightX from '../assets/X.png';
	import darkX from '../assets/XWhite.png';
	import plusIcon from '../assets/PlusLightTheme.png';
	import plusIconDark from '../assets/PlusDarkTheme.png';

	const props = defineProps({
		currentTheme: { type: String, required: true },
		availableNetworks: { type: Array, required: true}
	});
	
	const emit = defineEmits([
		'close',
		'add-network'
	]);
</script>

<style scoped>
	.popup-bg {
		background: var(--popup-bg-color);
	}
</style>
